import loadable from '@loadable/component';

/* istanbul ignore next */
export const NewbuildingBrokerBookingExistsModalAdapterLoadable = loadable(
  () =>
    import('./NewbuildingBrokerBookingExistsModalAdapter').catch(() => ({
      NewbuildingBrokerBookingExistsModalAdapter: () => null,
    })),
  {
    resolveComponent: ({ NewbuildingBrokerBookingExistsModalAdapter }) => NewbuildingBrokerBookingExistsModalAdapter,
    ssr: false,
  },
);
